import './LookupFieldMetadata.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { usePeriscopeActions } from '@hooks';
import { SonarObjectType } from '@sonar-software/sonar-ts-types';
export const LookupFieldMetaData = ({ index, lookupEntities }) => {
    const { openPeriscope } = usePeriscopeActions();
    if (lookupEntities.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: 'lookup-field-metadata' }, lookupEntities.map((entity) => {
        const { displayName, sonarObjectId: id } = entity;
        const [copyStart, copyEnd] = COPY_SPECIFIC.A_LOOKUP_ON_OBJECT.split('{0}');
        const objectLink = React.createElement("b", { className: 'clickable', onClick: () => openPeriscope({
                id,
                name: displayName,
                openedFromIndex: index,
                type: SonarObjectType.SalesforceEntity
            }) }, displayName);
        return (React.createElement("div", { key: id },
            copyStart,
            objectLink,
            copyEnd));
    })));
};
